export default "__VITE_ASSET__DUXQXDWU__"